// extracted by mini-css-extract-plugin
module.exports = {"sectionError":"SectionError_sectionError_nVFJn","error":"SectionError_error_1mYjb","notice":"SectionError_notice_1_s0C","spinAround":"SectionError_spinAround_2yue5"};